<p class="fc-terms-of-use">
    <span *ngIf="!showPdfLink">{{ termsOfUse }}</span>
    <a fcp-link *ngIf="showPdfLink" href="" (click)="openTermsModal($event)">{{
        'TERMS_OF_USE_PDF.OPEN' | translate
    }}</a>
</p>
